/**
 * @voltxampere/components — Resistor definition
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { z } from "zod";
export const ResistorParamsSchema = z
    .object({
    /** Resistance in ohms; must be strictly positive (no negative R, no short). */
    resistance: z.number().positive().finite(),
    /** Optional 1% / 5% / etc. tolerance in fractional units. */
    tolerance: z.number().nonnegative().finite().optional(),
    /** Optional power rating in watts. */
    powerRating: z.number().positive().finite().optional(),
})
    .strict();
export const resistorDefinition = {
    type: "resistor",
    category: "passive",
    displayName: { tr: "Direnç", en: "Resistor" },
    symbol: "R",
    pins: [
        { id: "p1", side: "left", offset: 0, label: "1" },
        { id: "p2", side: "right", offset: 0, label: "2" },
    ],
    parameterSchema: ResistorParamsSchema,
    nonlinear: false,
};
//# sourceMappingURL=resistor.js.map